import "./appLayout.scss";
import { useSelector } from "react-redux";
import { useEffect } from "react";

import AOS from "aos";
import "aos/dist/aos.css";

import RouteChange from "../hooks/useRouteChange";
import { Outlet } from "react-router-dom";
import { AppSidebar } from "./AppSidebar";
import { AppNavbar } from "./AppNavbar";

import { AuthGuard } from "../components/auth/AuthGuard";
import { OnlyFor } from "../components/Roles";
import {
  AGENT,
  CLIENT,
  DISTRIBUTOR,
  SUPER_DISTRIBUTOR,
} from "../consts/AppRoles";

const AppLayout = ({ children }) => {
  const currentUser = useSelector((s) => s.auth.currentUser);

  // Avoid Right Clicking Inside App
  useEffect(() => {
    AOS.init();
    // window.oncontextmenu = function (e) {
    //   return false;
    // };
  }, []);

  return (
    <>
      {/* Authentication Guard */}
      <RouteChange />
      <AuthGuard>
        <div className="app">
          {/* sidebar */}
          <AppSidebar />

          {/* content */}
          <div className="app-content-wrapper">
            <AppNavbar />
            <div className="app-content">
              <OnlyFor
                roles={[CLIENT, SUPER_DISTRIBUTOR, DISTRIBUTOR, AGENT]}
                role={currentUser?.productType}
              >
                <Outlet />
                <AppFooter />
              </OnlyFor>
            </div>
          </div>
        </div>
      </AuthGuard>
    </>
  );
};

export const SectionCard = ({ title, children, ...props }) => {
  return (
    <>
      <div className="app-section">
        {title && (
          <div className="app-section-header">
            <h4>{title}</h4>
          </div>
        )}
        <div className="app-section-content" {...props}>
          {children}
        </div>
      </div>
    </>
  );
};

export const AppFooter = () => {
  return (
    <>
      <div className="app-footer py-2 border-top border-light">
        <p className="text-center text-muted m-0">
          <small> MoXey - Beyond Payments</small>
        </p>
      </div>
    </>
  );
};
export default AppLayout;
